// import Swiper JS
import Swiper, { Navigation, Pagination, Mousewheel, Autoplay } from 'swiper';

const $ = window.jQuery;

const popularCat = {
	init() {
		const $popularCat = $(document).find('.catSwiperContainer');

		if (!$popularCat.length) return;

		// configure Swiper to use modules
		Swiper.use([Navigation, Pagination, Mousewheel, Autoplay]);

		const swiper = new Swiper('.catSwiper', {
			slidesPerView: 1.4,
			spaceBetween: 10,
			loop: false,
			cache: true,
			lazy: true,
			infinit: false,
			autoplay: {
				delay: 6500,
				disableOnInteraction: false,
			},
			mousewheel: {
				forceToAxis: true,
			},
			breakpoints: {
				// when window width is >= 480px
				420: {
					slidesPerView: 1.8,
					spaceBetween: 20,
				},
				// when window width is >= 640px
				640: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				/* 	// when window width is >= 840px
				940: {
					slidesPerView: 3,
					spaceBetween: 40,
				}, */
				940: {
					slidesPerView: 4,
					spaceBetween: 40,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			/* 	pagination: {
					el: '.swiper-pagination',
					clickable: true,
				}, */
		});
	},
};

export default popularCat;
